import React, { Fragment, useContext, useState } from "react";
import AuthContext from "../../../services/firebase/auth-context/provider";
import CodeRedeemStart from "./code-redeem-start";
import CodeRedeemResult from "./code-redeem-result";
import CodeRedeemAuth from "./code-redeem-auth";
import CodeRedeemSubscribe from "./code-redeem-subscribe";
import { RedeemState } from "./util";
var CodeRedeem = function CodeRedeem(_ref) {
    var checkResponse = _ref.checkResponse;
    var authenticated = useContext(AuthContext)[0].authenticated;
    var _useState = useState(RedeemState.START), redeemState = _useState[0], setRedeemState = _useState[1];
    var _useState2 = useState(undefined), subscriptionResult = _useState2[0], setSubscriptionResult = _useState2[1];
    if (!checkResponse.assignedArticles || checkResponse.assignedArticles.length <= 0)
        return /*#__PURE__*/ React.createElement(Fragment, null);
    return /*#__PURE__*/ React.createElement("div", {
        className: "mt-4"
    }, redeemState === RedeemState.START ? /*#__PURE__*/ React.createElement(CodeRedeemStart, {
        checkResponse: checkResponse,
        setRedeemState: setRedeemState
    }) : redeemState === RedeemState.SUBSCRIBE && !authenticated ? /*#__PURE__*/ React.createElement(CodeRedeemAuth, null) : redeemState === RedeemState.SUBSCRIBE && authenticated ? /*#__PURE__*/ React.createElement(CodeRedeemSubscribe, {
        checkResponse: checkResponse,
        setRedeemState: setRedeemState,
        setSubscriptionResult: setSubscriptionResult
    }) : /*#__PURE__*/ React.createElement(CodeRedeemResult, {
        subscriptionResult: subscriptionResult
    }));
};
export default CodeRedeem;
